import React from 'react';

import { toast } from 'bulma-toast';
import server from '../../../../utilities/server';

const DeleteOrder = ({ modal, setModal, refetch, data }) => {
	const [loading, setLoading] = React.useState(false);

	const _submit = () => {
		setLoading(true);
		server({
			method: 'delete',
			path: `orders/${data.id}`,
		}).then(() => {
			toast({ type: 'is-success', position: 'center', message: 'تمت حذف الطلب بنجاح' });
			refetch();
			setModal({ id: 0, name: '', email: '', role: '', });
			setLoading(false);
		}).catch(() => {
			toast({ type: 'is-danger', position: 'center', message: 'خطأ أثناء حذف الطلب' });
			setModal({ id: 0, name: '', email: '', role: '', });
			setLoading(false);
		});
	}

	return (
		<div className={`modal ${modal ? 'is-active' : ''}`}>
			<div className='modal-background' onClick={() => setModal({ id: 0, name: '', email: '', role: '', })}></div>
			<div className='modal-card'>
				<header className='modal-card-head'>
					<p className='modal-card-title'>حذف الطلب رقم {data.id}</p>
					<a className='delete' aria-label='close' onClick={() => setModal({ id: 0, name: '', email: '', role: '', })}></a>
				</header>
				<div className='modal-card-body'>
					<div className='notification is-danger'>
						سيتم حذف الطلب وجميع الاضافات والسجلات المرتبطة به. هل أنت متأكد من الاستمرار؟
					</div>
				</div>
				<footer className='modal-card-foot'>
					<a type='button' className='button' data-bs-dismiss='modal' onClick={() => setModal({ id: 0, name: '', email: '', role: '', })}>اغلاق</a>
					<button type='button' className='button is-danger' onClick={ _submit } disabled={loading}>حذف</button>
				</footer>
			</div>
		</div>
	)
};

export default DeleteOrder;
